export default "__VITE_ASSET__Bzk9CvMd__"